export default __webpack_public_path__ + "static/media/PayPal.5fe0f818.svg";